import styled from 'styled-components'

interface DatePickerPopoverStyledProps {
  anchorDirection: 'left' | 'right'
}

export const DatePickerPopoverStyled = styled.div<DatePickerPopoverStyledProps>`
  position: absolute;
  z-index: 1000;
  background: white;
  box-shadow: ${(props) => props.theme.shadows[1]};
  border-radius: ${(props) =>
    props.theme.typography.pxToRem(props.theme.shape.borderRadius)};
  display: flex;

  ${(props) => props.anchorDirection}: 0;

  top: calc(100% + ${(props) => props.theme.space.xsmall});

  padding: ${(props) => props.theme.space.small};
`
